"use client";

import { useEffect, useState } from "react";
import { getPusherClient } from "./pusherClient";

export function useOrderUpdates(orderId, customerId) {
  const [data, setData] = useState(null);
  const [connectionState, setConnectionState] = useState("connecting");

  useEffect(() => {
    if (!orderId || !customerId) return;
    const pusher = getPusherClient();
    const channelName = `order-updates.${orderId}.customer.${customerId}`;
    const channel = pusher.subscribe(channelName);
    channel.bind("order.scan.updated", (payload) => {
      setData(payload.data ?? payload);
    });

    pusher.connection.bind("state_change", (states) => {
      setConnectionState(states.current);
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe(channelName);
    };
  }, [orderId, customerId]);

  return { data, connectionState };
}

export function useOrderListing(customerId) {
  const [data, setData] = useState(null);
  const [connectionState, setConnectionState] = useState("connecting");

  useEffect(() => {
    if (!customerId) return;

    const pusher = getPusherClient();
    const channelName = `order-list.customer.${customerId}`;

    const channel = pusher.subscribe(channelName);

    channel.bind("order.list.updated", (payload) => {
      setData(payload.data ?? payload);
    });

    pusher.connection.bind("state_change", (states) => {
      setConnectionState(states.current);
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe(channelName);
    };
  }, [customerId]);

  return { data, connectionState };
}
